<template>
	<div class="add_backimgIndex">
		<div class="main_banner clearfix">
			<img src="@/images/main_banner.png" class="l" />
		</div>
		<div class="animal_list_infocontrol" v-if="menushow" >
			<div class="animal_list_itemcontrol" @click="setPosition(index)" :class="menuActive == index?'active':''" v-for="(item,index) in menuList">
				<i class="el-icon-caret-right animal_list_itemcontrolicon"></i>
				<span>{{item}}</span>
			</div>
		</div>
		<div class="main_content main_content_scroll">
			<div class="main_nav">
				教学情况
				<span class="r">
				首页>教学情况
			</span>
			</div>
			<div class="main_textcenter">
				<div class="main_label main_labeltext">本中心教学情况(2021年-2023年）</div>
			</div>
			<div class="main_table">
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td colspan="2" rowspan="2">
							<div class="main_tableP1">本中心教学情况 (2021年-2023年）</div>
						</td>
						<td>
							<div class="main_tableP2">实验课程数</div>
						</td>
						<td>
							<div class="main_tableP2">面向专业数</div>
						</td>
						<td colspan="2">
							<div class="main_tableP2">实验学生人数/年</div>
						</td>
						<td colspan="2">
							<div class="main_tableP2">实验人时数/年</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP3">29</div>
						</td>
						<td>
							<div class="main_tableP3">3</div>
						</td>
						<td colspan="2">
							<div class="main_tableP3">2082</div>
						</td>
						<td colspan="2">
							<div class="main_tableP3">78199</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP2">序号</div>
						</td>
						<td>
							<div class="main_tableP2">实验课名称</div>
						</td>
						<td>
							<div class="main_tableP2">主讲教师</div>
						</td>
						<td>
							<div class="main_tableP2">学位</div>
						</td>
						<td>
							<div class="main_tableP2">专业技术职务</div>
						</td>
						<td>
							<div class="main_tableP2">面向专业</div>
						</td>
						<td>
							<div class="main_tableP2">实验学生人数/年</div>
						</td>
						<td>
							<div class="main_tableP2">实验人时数/年</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList1">
						<td>
							<div class="main_tableP4">{{index+1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div v-for="it in item.data2">{{it}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div v-for="it in item.data3">{{it}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div v-for="it in item.data4">{{it}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data5}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data6}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data7}}</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="main_textcenter">
				<div class="main_label main_labeltext">本中心教材建设（2016年以来）</div>
			</div>
			<div class="main_table main_tableno">
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td colspan="2" rowspan="3">
							<div class="main_tableP1">本中心教材建设（2016年以来）</div>
						</td>
						<td colspan="2">
							<div class="main_tableP2">出版实验教材数量（种）</div>
						</td>
						<td colspan="2" rowspan="3">
							<div class="main_tableP2">自编实验讲义数量（种）</div>
						</td>
						<td rowspan="3">
							<div class="main_tableP2" style="width: 260px;">2</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP2">主编</div>
						</td>
						<td>
							<div class="main_tableP2">参编</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP3">3</div>
						</td>
						<td>
							<div class="main_tableP3">2</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="main_table">
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td>
							<div class="main_tableP2">序号</div>
						</td>
						<td colspan="2">
							<div class="main_tableP2">出版实验教材名称</div>
						</td>
						<td>
							<div class="main_tableP2">编者</div>
						</td>
						<td>
							<div class="main_tableP2">主编/参编</div>
						</td>
						<td>
							<div class="main_tableP2">出版社及出版时间</div>
						</td>
						<td>
							<div class="main_tableP2">获奖情况</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList2">
						<td>
							<div class="main_tableP4">{{index+1}}</div>
						</td>
						<td colspan="2">
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div class="main_tableP4">{{item.data2}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div class="main_tableP4">{{item.data3}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">
								<div class="main_tableP4">{{item.data4}}</div>
							</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data5}}</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="main_videoclick clearfix">
				<img src="@/images/main_videoback.png" class="main_videoback l" />
				<div class="main_video_main clearfix" @click="dialogVisible = true">
					<img src="@/images/main_video_main.png" class="main_videoback l" />
					<img src="@/images/main_video_mainplay.png" class="main_video_mainplay" />
				</div>
			</div>
			<div class="main_label">本实验教学中心教学理念</div>
			<div class="main_text">
				“中心”的实验教学理念是：以学生为主，“厚基础、重能力、强实践”。“厚基础”即在实验教学过程中加强学生基础知识和基本操作的培养和巩固，注意理论联系实际；“重能力”即在实验教学过程中重视培养学生的学习能力、动手能力和综合实验能力；“强实践”即在实验教学过程中鼓励学生不受实验室、实验学时和实验教材的限制，自行设计实验方案和完成实验，以培养学生的创新意识和创新能力。通过打造实践教学基地、行业培训基地和创新人才培训基地促进教学理念落地生根。
			</div>
			<div class="main_text main_textbord">
				（1）实践教学基地
			</div>
			<div class="main_text">
				在实验教学中，“中心”按照学生认识、理解、掌握知识的规律，遵循促进学生实践能力梯级递增，注重学生个性发展的原则，构建分层次的实验教学体系和模式。
			</div>
			<div class="main_text main_textbord">
				（2）行业培训基地
			</div>
			<div class="main_text">
				随着现代科技技术的发展，医学影像学、医学影像技术和生物医学工程在理论和技术上都有了很大的发展，“中心”以已有的先进实验项目为基础，充分利用自身的实践教学条件，发挥资源优势，扩大辐射作用，逐渐成为校外同行业一线技术人员的交流和培训基地。
			</div>
			<div class="main_text main_textbord">
				（3）创新人才培训基地
			</div>
			<div class="main_text">
				按照不同年级的学生，构建了多层次的实验教学体系，根据不同知识层次的实验主体，设计了有基础认识实验、技能训练实验、综合实践实验和应用创新实验。通过大学生专业竞赛等活动励学生积极参加，自主思考，勇于探索，构建了一个从认识、掌握、应用到创新的实验教学体系。
			</div>
			<img src="@/images/teacher_img1.png" class="main_img" />
			<div class="main_label">虚拟仿真实验教学资源</div>
			<div class="main_text main_textbord main_textbordline">
				（1）自主开发：
			</div>
			<img src="@/images/teacher_img2.png" class="main_img main_imgsmall" />
			<div class="main_text main_textbord main_textbordline">
				（2）校企共建：
			</div>
			<img src="@/images/teacher_img3.png" class="main_img" />
			<div class="main_text main_textbord ">
				（3）典型实验：
			</div>
			<div class="main_text main_textbord ">
				①医学影像设备学
			</div>
			<div class="main_text">
				含CT设备拆解认知、DR设备拆解认知、MRI设备拆解认知、放疗设备拆解认知。两种模式：训练模式、考核模式。对相关的影响常用设备进行内部拆解，各个零部件可进行任意角度的3D旋转、放大，并配有相关的介绍说明。以剖面图等方式展现各部件的精准结构位置。可通过该软件实现影像设备的整体认知、虚拟操作、内部构造拆解、维修知识等学习工作需求。
			</div>
			<div class="main_text">
				比如DR设备按照真实设备1:1，3D建模复刻还原。软件架构为B/S架构；支持校园局域网内任何电脑通过浏览器访问学习。界面分为结构部分、剖面部分及单个零部件单元设置。支持对整体或分体或部件的任意放大、缩小、旋转。
			</div>
			<div class="main_text main_textbord ">
				②医学影像检查技术学
			</div>
			<div class="main_text">
				如CT检查步骤包括：核对信息、换着更衣 信息输入、穿防护衣、摆位、体位选择、调整机器、扫描参数设置、定位片范围交互操作、扫描、重建图像、扫描结束、图像后期处理、人体断层。
			</div>
			<div class="main_text">
				人机交互的模式模拟整个检查过程。以交互或者对话展现扫描的介绍、金属异物的去除、护具选择、患者的安抚、患者注意事项的叮嘱。以交互方式设置体位、定位片及基准线、扫描参数的设定。摆位时需具备快速升降床位及微调步进床位的按钮设置及相对应功能。在操作基准线设定错误时，有相应的提示说明。在定位片设置范围交互操作错误时进行相关提示。支持在扫描的同时，展现CT机工作原理的3D展示。
			</div>
			<div class="main_text main_textbord ">
				③医学影像成像理论
			</div>
			<div class="main_text">
				含X线成像原理、X线机结构原理及故障排除、CT成像原理、MRI成像原理、MRI成像系统设备结构原理与调试：通过三维方式的构建设计、对平时教学中晦涩难懂的成像原理部分，进行直观的体现。其内容涉及面广，X线机、CT、MRI等多个维度进行原理的集中讲解学习。并结合相关考核方式，通过新颖的人机互动操作，将抽象内容形象化、具体化。人体断层。
			</div>
			<div class="main_text main_textnoma">a．MRI室搭建
			</div>
			<div class="main_text main_textnoma"> b．MRI结构及组成
			</div>
			<div class="main_text main_textnoma"> c．人体质子磁共振现象
			</div>
			<div class="main_text main_textnoma"> d．在静磁场强度与氢质子的能极差
			</div>
			<div class="main_text main_textnoma"> e．射频场的产生与作用
			</div>
			<div class="main_text main_textnoma"> f．线性梯度磁场的原理作用于构成及空间编码
			</div>
			<div class="main_text main_textnoma"> g．K空间填充
			</div>
			<div class="main_text main_textnoma"> h．磁共振成像参数
			</div>
			<div class="main_text "> i．多模态图像融合技术
			</div>
			<div class="main_text main_textbord ">
				（4）放射治疗设备
			</div>
			<div class="main_text">
				含常见直线加速器、Tomotherapy、Cyberknife、磁共振减速器、γ刀、质子放疗设备、图像引导放疗设备的拆解认知、及基本零部件的组装。两种模式：训练模式、考核模式。对相关的影响常用设备进行内部拆解，各个零部件可进行任意角度的3D旋转、放大，并配有相关的介绍说明。以剖面图等方式展现各部件的精准结构位置。可通过该软件实现放射治疗设备的整体认知、虚拟操作、内部构造拆解、维修知识等学习工作需求。
			</div>
			<div class="main_text">
				比如VARIAN Vital Beam直线极速器按照真实设备1:1，3D建模复刻还原。软件架构为B/S架构；支持校园局域网内任何电脑通过浏览器访问学习。界面分为结构部分、剖面部分及单个零部件单元设置。支持对整体或分体或部件的任意放大、缩小、旋转。主要分为：
			</div>
			<div class="main_text main_textnoma"> 1）放疗设备的整体框架模型
			</div>
			<div class="main_text main_textnoma"> 2）放疗设备的内部剖面模型
			</div>
			<div class="main_text main_textnoma"> 3）放疗设备基本运行模拟模型
			</div>
			<div class="main_text main_textnoma"> 4）放疗设备多维度机械运动模型
			</div>
			<div class="main_text "> 5）放疗设备图像引导装置工作模型
			</div>
			<div class="main_text main_textbord ">
				（5）放射治疗工作流程
			</div>
			<div class="main_text">
				针对肿瘤放射治疗工作中体位选择、固定装置选择、CT或MR模拟定位、靶区及危及器官勾画、放疗计划设计、放疗计划验证、放疗计划实施等环节，依托VR可视化工具，对患者这个放疗流程进行虚拟展示及互动，以满足广大学生在校园中即可接受身临其境的放射治疗流程的教学及时间操作模拟。
			</div>
			<div class="main_text">
				比如一例鼻咽癌虚拟患者，在明确诊断后，开始进入放射治疗的环节，从患者体位选择、热塑面膜制定、CT模拟定位、MR模拟定位、CT及MR融合配准，确定肿瘤靶区、确定周围眼睛、脑干等危及器官，光子及质子放疗技术选择、IMRT及VMAT、质子放疗计划优化、放疗剂量分布立体显示、放疗计划评估、患者模拟实际放疗等环节，以虚拟人的形式，通过节点式的控制及参与，充分展示及帮助学生理解放疗的过程及注意事项。主要包括：
			</div>
			<div class="main_text main_textnoma">
				1）放疗体位固定装置模型
			</div>
			<div class="main_text main_textnoma">
				2）放疗模拟定位模型
			</div>
			<div class="main_text main_textnoma">
				3）放疗靶区及危及器官虚拟勾画模型
			</div>
			<div class="main_text main_textnoma">
				4）放疗计划虚拟设计模型
			</div>
			<div class="main_text main_textnoma">
				5）放疗计划虚拟验证模型
			</div>
			<div class="main_text ">
				6）患者放射治疗虚拟放疗模型
			</div>
			<div class="main_text main_textbord ">
				（6）放射治疗质控理论及实践
			</div>
			<div class="main_text">
				针对放射治疗质控常用的设备及分析，构建设备及操作系统的虚拟显示平台，从放疗设备的数据厂家验收、数据采集、放疗计划系统数据建模、放疗计划剂量验证的各个环节入手，实现放疗质控操作的理论及实践虚拟教学。
			</div>
			<div class="main_text">
				比如以质子放疗设备为例，在设备安装完成后，应用二维水箱等对质子射束进行厂家验收，验收合格，通过三维水箱采集质子射束数据，通过拟合构建质子放疗计划数据模型，根据数据模型，对模块化的射野进行计划设计和剂量分布的三维展示；虚拟选择一例常见肿瘤患者（如脑肿瘤），对其进行质子放疗计划的设计及剂量计算；用三维剂量验证系统，验证计划剂量分布在人体中的实际情况。主要包括：
			</div>
			<div class="main_text main_textnoma">
				1）放射治疗质控设备硬件虚拟现实模型
			</div>
			<div class="main_text main_textnoma">
				2）放射治疗质控操作流程虚拟化控制模型
			</div>
			<div class="main_text main_textnoma">
				3）放射治疗质控结果虚拟分析模型
			</div>
			<div class="main_text main_textnoma">
				4）放疗设备剂量学数据及分析模型
			</div>
			<div class="main_text ">
				5）放射治疗计划验证数据虚拟获取及分析模型
			</div>
			<div class="main_label">本实验教学中心教学体系与教学内容</div>
			<div class="main_text main_textbord ">
				（1）根据实验教学规律和人才成长规律，建立以能力培养为主线，目标清晰、载体明确、评价科学的实验教学体系和质量标准。
			</div>
			<div class="main_text">
				建立以实验教学中心为依托，与有关部门、科研院所、行业企业联合培养人才的新模式。重视基本规范的养成，重视基础能力的培养，重视与科学前沿、工程实际和社会应用实践的密切联系。
			</div>
			<div class="main_text main_textbord ">
				（2）先进的实验教学方式方法和内容
			</div>
			<div class="main_text">
				创新和使用多样化的教学方法、现代化的教学手段，积极开发综合性、设计性、创新性实验项目。
			</div>
			<div class="main_text">
				重点实行以学生为本的基于问题、项目、案例的互动式、研讨式教学方式和自主、合作、探究的学习方式。
			</div>
			<div class="main_text">
				注重基础与前沿、经典与现代相结合，虚拟仿真与真实体验相结合，基本规范养成、基础能力训练与创新能力培养相结合，有效提高学生实践能力，促进学生多样化成才。
			</div>
			<div class="main_label">合作企业的概况、参与程度和合作成果</div>
			<div class="main_text ">
				和多家企业广泛合作，主要采取优势互补的方式与企业展开合作。具体形式是，由我校教师首先负责提出整体方案要求，教师结合课程，分工设计各仿真训练模块的具体内容和技术指标；负责仿真平台的技术实现和开发，并提供服务支持。
			</div>
			<div class="main_text main_textbord ">
				共同开发虚拟仿真实验项目，制作仿真模型，搭建竞赛和职业能力技能考核平台，同时也为企业提供培训、安全教育等相关服务：
			</div>
			<div class="main_text">
				（1）与山东中飞科技有限公司共同开发虚拟仿真实验项目，并搭建全国医学影像技术专业职业能力综合测试平台，顺利完成两年联考工作。公司致力于为客户提供富有创新性和可操作性的软件系统及解决方案, 产品覆盖：三维动画制作、三维仿真教学软件开发、虚拟实验系统平台软件、多媒体教学设备、医学影像及放射治疗仿真软件, Internet 网站建设，虚拟展示及操作系统集成。
			</div>
			<div class="main_text">
				（2）与上海培云教育科技有限公司共同开发实验项目，联合编写实验教材，搭建全国“泰山杯”实践技能大赛。公司业务主要包括：教育科技软件、生物科技、医疗器械科技领域内的技术开发、技术咨询、技术转让、技术服务。公司团队包括20年的核磁教学科研经历国内知名专家，主持开发过多款核磁科研和工业用仪器并进入市场，承担科技部重大科学仪器项目仪器开发子任务。
			</div>
			<div class="main_text">
				（3）与上海梦之路数字科技有限公司共同开发实验项目，搭建全国“泰山杯”实践技能大赛。公司业务主要包括：多媒体数字技术的研发，计算机软硬件的技术开发、技术转让、销售，系统集成，展览展示服务，动漫设计、制作，通讯产品、电子产品的开发、销售，网络工程的安装、调试、维护等。
			</div>
			<div class="main_text">
				（4）与北京嘉茂宏商贸有限公司共同开发实验项目，搭建全国“泰山杯”实践技能大赛。公司致力于提供医疗产品与医疗维修服务、医学教育产品研发、生产的企业。通过对医疗、教育以及维修服务的资源整合、秉承优势产品互补、学科专业发展、医疗与教学流程改善、“一站式”维修服务的发展原则，迅速建立起业内着称的”一站式”体系化的服务平台。
			</div>
			<div class="main_text">
				（5）与重庆华教科技有限公司共同开发实验项目，搭建全国“泰山杯”实践技能大赛。是一家集教育软件、医疗信息化系统研发、销 售、服务为一体的高科技企业，是教育部产学合作协同育人项目参与企业。
			</div>
			<div class="main_label">本实验教学中心教学资源共享的范围、效果及措施</div>
			<div class="main_text">
				智能医学影像与放射治疗虚拟仿真实验教学中心在以下方面完成了初步的共享：
			</div>
			<div class="main_text">
				<b>
					（1）智能平台的共享。
				</b> 通过竞赛平台和职业能力综合测试平台的运行，中心已逐步开放共享整个虚拟仿真实验平台。
			</div>
			<div class="main_text">
				<b>
					（2）数据资源的共享。
				</b> 中心从学科特点出发，近年来通过自主开发、校企共建及共享资源等方式丰富平台资源，与四川大学、重庆医科大学、南京医科大学、首都医科大学、上海健康医学院等40余所高校共享资源，培养实验教学师资150余人。
			</div>
			<div class="main_text">
				<b>
					（3）管理资源的共享。
				</b> 学校由现代教育技术中心牵头，统一对学校的虚拟仿真实验平台行管理。最大程度地共享管理模式和管理资源。
			</div>
			<div class="main_text">
				<b>
					（4）网上网下交互学习。
				</b> 为拓宽学生课程和实验学习的时间和空间，增强学生学习的自主性，中心将常规的实验项目和实验课程资源转变为以音频、视频、图片、动画、文本等各种媒体表现形式的多媒体资源，使学生在课前预先了解实验内容、实验项目、授课教师等情况；部分课程采用课堂教学和网上教学相结合的混合式学习方法，学生可以通过授课教师搭建的课程网上信息平台完成网上预习、复习以及课堂实验内容的学习；学生在课外可以随时进入自主学习平台，学生之间、师生之间可以通过网站进行交流、讨论、提问和解答问题等。
			</div>
			<div class="main_label">本实验教学中心教学成果</div>
			<div class="main_table">
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td colspan="5">
							<div class="main_tableP2">虚拟仿真实验成果、获奖</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP2">序号</div>
						</td>
						<td>
							<div class="main_tableP2">获得时间</div>
						</td>
						<td>
							<div class="main_tableP2">项目/课程名称</div>
						</td>
						<td>
							<div class="main_tableP2">项目类别</div>
						</td>
						<td>
							<div class="main_tableP2">批准/颁发单位</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList3">
						<td>
							<div class="main_tableP4">{{index+1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data2}}</div>
						</td>
						<td v-if="item.data5" :rowspan="item.data5 && item.data5>0?item.data5 : 1">
							<div class="main_tableP4">{{item.data3}}</div>
						</td>
						<td v-if="item.data6" :rowspan="item.data6 && item.data6>0?item.data6 : 1">
							<div class="main_tableP4">{{item.data4}}</div>
						</td>
					</tr>
					<tr>
						<td colspan="5">
							<div class="main_tableP2">专业获奖</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList4">
						<td colspan="2">
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data2}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data3}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data4}}</div>
						</td>
					</tr>
					<tr>
						<td colspan="5">
							<div class="main_tableP2">教师获奖</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList5">
						<td colspan="2">
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data2}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data3}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data4}}</div>
						</td>
					</tr>
					<tr>
						<td colspan="5">
							<div class="main_tableP2">学生获奖</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList6">
						<td colspan="2">
							<div class="main_tableP4">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data2}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data3}}</div>
						</td>
						<td>
							<div class="main_tableP4">{{item.data4}}</div>
						</td>
					</tr>
				</table>
			</div>
			<img src="@/images/teacher_img4.png" class="main_img" />
			<div class="main_label">本实验教学中心教学质量保障制度措施</div>
			<div class="main_text">
				（1）坚持<b>
					科学规划、资源整合、开放共享、高效管理
				</b> 原则，对实验教学中心建设进行科学规划，对实验教学资源和相关教育资源进行整合，建设面向多学科、多专业的实验教学中心。
			</div>
			<div class="main_text">
				（2）<b>
					理顺实验教学中心管理体制
				</b> ，实行中心主任负责制。建设有利于学生自主实验、个性化学习的实验环境，建立健全评价与保障机制，完善并落实实验教学质量保障体系。
			</div>
			<div class="main_text">
				（3）<b>
					创新对外交流与合作模式
				</b> ，利用科研院所、行业企业人才和技术优势，建设校内外互惠互利、可持续发展的实践育人条件。
			</div>
			<div class="main_text">
				实验教学中心特色鲜明，实验教学效果显著，建设成果丰富，受益面广，学生实验兴趣浓厚，自主学习能力增强，实践创新能力明显提高，发挥了良好的示范作用。
			</div>
		</div>
		<el-dialog title="磁共振成像原理虚拟仿真实验" :visible.sync="dialogVisible" width="900px">
			<video src="@/images/1.mp4" style="width: 100%;height: 520px;background: #000000;" controls="controls" v-if='dialogVisible' />
		</el-dialog>
	</div>
</template>

<script>
	import { heightToTop } from "@/utils/auth.js"
	export default {
		data() {
			return {
				menuList: ['本中心教学情况(2021年-2023年）', '本中心教材建设（2016年以来）', '本实验教学中心教学理念', '虚拟仿真实验教学资源', '本实验教学中心教学体系与教学内容', '合作企业的概况、参与程度和合作成果', '本实验教学中心教学资源共享的范围、效果及措施', '本实验教学中心教学成果', '本实验教学中心教学质量保障制度措施'],
				menuActive: 0,
				menushow: false,
				dialogVisible: false,
				dataList1: [{
					data1: '放射治疗剂量学',
					data2: ['王鹏程', '侯立霞'],
					data3: ['博士', '博士'],
					data4: ['教授', '副教授'],
					data5: '医学影像技术、应用物理学',
					data6: '264',
					data7: '2490',
				}, {
					data1: '医学影像技术科研创新与创新实验',
					data2: ['邱建峰', '侯庆锋'],
					data3: ['博士', '博士'],
					data4: ['教授', '副教授'],
					data5: '医学影像技术',
					data6: '144',
					data7: '6912',
				}, {
					data1: '放射治疗设备学',
					data2: ['何乐民'],
					data3: ['博士'],
					data4: ['教授'],
					data5: '医学影像技术、应用物理学',
					data6: '47',
					data7: '188',
				}, {
					data1: '医学影像设备学',
					data2: ['齐现英', '韩丰谈'],
					data3: ['博士', '硕士'],
					data4: ['副教授', '教授'],
					data5: '医学影像技术、生物医学工程、应用物理学',
					data6: '1012',
					data7: '13430',
				}, {
					data1: '医学影像检查技术',
					data2: ['于兹喜', '赵慧慧'],
					data3: ['硕士', '硕士'],
					data4: ['教授', '讲师'],
					data5: '医学影像技术、应用物理学',
					data6: '569',
					data7: '11493',
				}, {
					data1: '医学影像成像理论',
					data2: ['侯庆锋', '马德鹏'],
					data3: ['博士', '博士'],
					data4: ['副教授', '讲师'],
					data5: '医学影像技术、生物医学工程、应用物理学',
					data6: '453',
					data7: '3505',
				}, {
					data1: '放射治疗技术学',
					data2: ['刘金锋', '尹勇'],
					data3: ['博士', '博士'],
					data4: ['副教授', '教授'],
					data5: '医学影像技术、应用物理学',
					data6: '264',
					data7: '2117',
				}, {
					data1: '磁共振成像原理',
					data2: ['窦汝海'],
					data3: ['博士'],
					data4: ['讲师'],
					data5: '医学影像技术',
					data6: '114',
					data7: '1026',
				}],
				dataList2: [{
					data1: '放射物理与防护（含实验',
					data2: '王鹏程',
					data3: '主编',
					data4: '人民卫生出版社，2019年',
					data5: '全国优秀教材一等奖',
				}, {
					data1: '医学影像设备学（含实验）',
					data2: '韩丰谈',
					data3: '主编',
					data4: '人民卫生出版社，2016年',
					data5: '山东省一流教材',
				}, {
					data1: '放射物理与辐射防护（含实验）',
					data2: '王鹏程',
					data3: '主编',
					data4: '人民卫生出版社，2016年',
					data5: '山东省一流教材',
				}, {
					data1: '医学电子学基础（含实验）',
					data2: '鲁雯',
					data3: '主编',
					data4: '人民卫生出版社，2022年',
					data5: '山东省一流教材',
				}, {
					data1: '磁共振引导肿瘤放射治疗学',
					data2: '于金明',
					data3: '主编',
					data4: '科学出版社，2022年',
					data5: '',
				}, {
					data1: '肿瘤临床通鉴',
					data2: '于金明',
					data3: '主编',
					data4: '山东科学技术出版社，2004年',
					data5: '',
				}, {
					data1: '乳腺疾病学',
					data2: '于金明',
					data3: '主编',
					data4: '人民卫生出版社，2007年',
					data5: '',
				}, {
					data1: '放射免疫新实践',
					data2: '于金明',
					data3: '主编',
					data4: '科学技术文献出版社，2021年',
					data5: '',
				}, {
					data1: '放射治疗设备学（含实验）',
					data2: '何乐民',
					data3: '副主编',
					data4: '人民卫生出版社，2016年',
					data5: '',
				}, {
					data1: '医学影像设备学（含实验）',
					data2: '何乐民',
					data3: '副主编',
					data4: '人民卫生出版社，2022年',
					data5: '',
				}],
				dataList3: [{
					data1: '2022.12',
					data2: '全国仿真创新应用大赛（何乐民）',
					data3: '一等奖',
					data4: '工信部',
					data5: 1,
					data6: 1,
				}, {
					data1: '2022.11',
					data2: '仿真创新应用大赛（何乐民）',
					data3: '一等奖',
					data4: '山东省',
					data5: 1,
					data6: 1,
				}, {
					data1: '2021.08',
					data2: '《磁共振成像原理虚拟仿真实验》',
					data3: '省级',
					data4: '山东省教育厅',
					data5: 2,
					data6: 2,
				}, {
					data1: '2020.03',
					data2: '《医学影像学虚拟仿真实验项目》',
				}, {
					data1: '2017.08',
					data2: '全国第二届虚拟仿真实验教学软件大赛（何乐民）',
					data3: '一等奖',
					data4: '教育部教指委',
					data5: 1,
					data6: 2,
				}, {
					data1: '2017.08',
					data2: '全国第二届虚拟仿真实验教学软件大赛',
					data3: '二等奖',
					data5: 1,
				}, {
					data1: '2017.08',
					data2: '医学影像质量控制仿真平台软件V1.0',
					data3: '著作权证书',
					data4: '国家版权局',
					data5: 13,
					data6: 13,
				}, {
					data1: '2017.08',
					data2: 'CT案例虚拟操作软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'MR案例虚拟操作软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'DR案例虚拟操作软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'CT成像原理虚拟仿真软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'CT设备结构原理与调试虚拟仿真软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'DR成像原理虚拟仿真软件V1.0',
				}, {
					data1: '2017.08',
					data2: 'MRI设备结构原理与调试虚拟仿真软件V1.0',
				}, {
					data1: '2017.08',
					data2: '诊断X线机模拟整流电路的搭建',
				}, {
					data1: '2017.08',
					data2: 'X射线机控制板虚拟故障排除',
				}, {
					data1: '2017.08',
					data2: '医用超声诊断仪器应用与维修案例',
				}, {
					data1: '2017.08',
					data2: '核磁共振成像原理虚拟仿真软件V1.0',
				}, {
					data1: '2017.08',
					data2: '虚拟影像博物馆软件V1.0',
				}],
				dataList4: [{
					data1: '2007年',
					data2: '国家级特色专业（医学影像学）',
					data3: '国家级',
					data4: '教育部',
				}, {
					data1: '2019年',
					data2: '国家级一流专业（医学影像技术）',
					data3: '国家级',
					data4: '教育部',
				}, {
					data1: '2021年',
					data2: '优秀教材建设成果',
					data3: '国家级一等奖',
					data4: '教育部',
				}, {
					data1: '2021年',
					data2: '优秀教材建设成果',
					data3: '国家级二等奖',
					data4: '教育部',
				}, {
					data1: '2021年',
					data2: '国家级科普教育基地（医学影像博物馆）',
					data3: '国家级',
					data4: '中国科学技术协会',
				}, {
					data1: '2015年',
					data2: '全国大学生医学影像技术专业实践技能大赛基地',
					data3: '国家级',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2019年',
					data2: '医学影像学',
					data3: '省级一流专业',
					data4: '山东省教育厅',
				}, {
					data1: '2019年',
					data2: '生物医学工程',
					data3: '省级一流专业',
					data4: '山东省教育厅',
				}, {
					data1: '2019年',
					data2: '应用物理学',
					data3: '省级一流专业',
					data4: '山东省教育厅',
				}, {
					data1: '2018年',
					data2: '山东省教育服务新旧动能转换专业',
					data3: '山东省',
					data4: '山东省教育厅',
				}, {
					data1: '2016年',
					data2: '山东省高水平应用型立项建设重点专业群（核心专业）',
					data3: '山东省',
					data4: '山东省教育厅',
				}, {
					data1: '2007年',
					data2: '医学影像技术实验教学示范中心',
					data3: '山东省',
					data4: '山东省教育厅',
				}, {
					data1: '2021年',
					data2: '山东省优秀教材建设成果',
					data3: '省级一流教材',
					data4: '山东省教育厅',
				}, {
					data1: '2008年',
					data2: '山东省高等学校优秀教材',
					data3: '一等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2008年',
					data2: '山东省高等学校优秀教材',
					data3: '二等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2018年',
					data2: '山东省教学成果奖（医学影像技术专业人才培养五元创新探索与实践）',
					data3: '省部级二等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2018年',
					data2: '山东省教学成果奖（临床应用型医学物理师人才培养模式及课程体系建设）',
					data3: '省部级二等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2014年',
					data2: '山东省教学成果奖（知识复合型高素质医学影像技术人才培养模式的研究与实践）',
					data3: '省部级二等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2009年',
					data2: '山东省教学成果奖（医学影像专业实验建设改革与探索）',
					data3: '省部级三等奖',
					data4: '山东省教育厅',
				}, {
					data1: '2009年',
					data2: '《医学影像学》',
					data3: '省级精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2011年',
					data2: '《医学影像检查技术学》',
					data3: '省级精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2011年',
					data2: '《医学影像解剖学》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2011年',
					data2: '《放射治疗剂量学》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2011年',
					data2: '《医学影像设备学》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2011年',
					data2: '《医学影像电子学》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2013年',
					data2: '《医用电子技术基础》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2013年',
					data2: '《医用电子线路辅助设计》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2014年',
					data2: '《生物医学信号处理》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2013年',
					data2: '《医学图像处理》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2013年',
					data2: '《医用电子仪器》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2013年',
					data2: '《医用电子技术基础》',
					data3: '山东省精品课程',
					data4: '山东省教育厅',
				}, {
					data1: '2020年',
					data2: '《生物医学传感器》',
					data3: '省级一流课程',
					data4: '山东省教育厅',
				}, {
					data1: '2020年',
					data2: '《医学影像学虚拟仿真实验项目》',
					data3: '省级虚拟仿真实验项目',
					data4: '山东省教育厅',
				}, {
					data1: '2021年',
					data2: '《医学图像处理》',
					data3: '省级一流课程',
					data4: '山东省教育厅',
				}, {
					data1: '2021年',
					data2: '《磁共振成像原理虚拟仿真实验》',
					data3: '省级虚拟仿真实验项目',
					data4: '山东省教育厅',
				}],
				dataList5: [{
					data1: '2021年',
					data2: '全国科普工作先进工作者',
					data3: '国家级',
					data4: '科技部、中宣部、科协',
				}, {
					data1: '2011年',
					data2: '山东省教学名师（王鹏程）',
					data3: '省部级',
					data4: '山东省教育厅',
				}, {
					data1: '2015年',
					data2: '全国大学生医学影像技术专业实践技能大赛基地秘书长',
					data3: '国家级',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2017年',
					data2: '全国第二届虚拟仿真实验教学软件大赛（何乐民）',
					data3: '一等奖',
					data4: '高等学校国家级实验教学示范中心联席会',
				}, {
					data1: '2017年',
					data2: '全国第二届虚拟仿真实验教学软件大赛（侯庆锋）',
					data3: '二等奖',
					data4: '高等学校国家级实验教学示范中心联席会',
				}, {
					data1: '2019年',
					data2: '第二届全国医学影像技术专业青年教师微课教学竞赛（朱烨）',
					data3: '二等奖',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2017年',
					data2: '首届全国高等院校医学影像专业教师教学基本功竞赛（赵昕）',
					data3: '三等奖',
					data4: '中国高等教育学会医学教育委员会',
				}, {
					data1: '2017年',
					data2: '省级优秀论文指导教师（何乐民）',
					data3: '省级优秀论文指导教师',
					data4: '山东省教育厅',
				}],
				dataList6: [{
					data1: '2014年',
					data2: '全国医学影像技术专业实践技能竞赛',
					data3: '团体特等奖',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2015年',
					data2: '全国医学影像技术专业实践技能竞赛',
					data3: '团体特等奖',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2018年',
					data2: '全国医学影像技术专业实践技能竞赛',
					data3: '团体特等奖',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2020年',
					data2: '全国医学影像技术专业实践技能竞赛',
					data3: '团体一等奖',
					data4: '中华医学会影像技术分会',
				}, {
					data1: '2021年',
					data2: '全国医学影像技术专业实践技能竞赛',
					data3: '团体第一名',
					data4: '中华医学会影像技术分会',
				}]
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				setTimeout(()=>{
				this.getAllHeight();
				},500)
			})
		},
		methods: {
			getAllHeight() {
				var heightList = [];
				this.menuActive = 0;
				this.$nextTick(() => {
					$('.main_label').map((index, item) => {
						heightList.push(heightToTop(item))
					})
					this.heightList = heightList;
					this.getPosition();
				})
			},
			getPosition() {
				var that = this;
				$(window).unbind('scroll');
				$(window).bind('scroll', function(e) {
					var scrollTop = $(window)[0].scrollY;
					var heightList = that.heightList;
					heightList.map((item, index) => {
						if(scrollTop >= heightList[index] && scrollTop < heightList[index + 1]) {
							that.menuActive = index
						}

					})
					if(scrollTop > 260) {
						that.menushow = true;
					} else {
						that.menushow = false;
					}
				})
			},
			setPosition(index) {
				this.menuActive = index;
				var heightTop = this.heightList[index];
				$(window)[0].scrollTo(0, heightTop);
			},
		},
	}
</script>